import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { useGetDatasetFilesQuery } from '~/api/v2/hooks';
import FileUploader from '~/components/FileUploader';

interface SupportiveDocumentsStepProps {
  files: File[];
  onFilesUpload: (files: File[] | null) => void;
}

const SupportiveDocumentsStep: FC<SupportiveDocumentsStepProps> = ({ files, onFilesUpload }) => {
  const datasetId = +useParams().id!;
  const { data, isLoading } = useGetDatasetFilesQuery({ datasetId, supportiveDocs: true });

  return (
    <Box>
      <FileUploader
        existingFiles={data || []}
        existingFilesLoading={isLoading}
        currentFiles={files}
        onChange={onFilesUpload}
        filesToImport="Supportive Documents"
        supportedDocuments={['Privacy memo', 'Secondary documents']}
      />
    </Box>
  );
};

export default SupportiveDocumentsStep;
